<template>
    <v-card elevation="0">
        <v-form :readonly="isReadonly">
            <v-row dense>
                <v-col cols="12" md="10">
                    <v-row dense>
                        <v-col cols="12" md="8">
                            <div outlined class="px-2">
                                <v-row>
                                    <v-col cols="12" md="4">
                                        <v-text-field
                                            v-model="form.nombre"
                                            label="Nombre"
                                            required
                                            prepend-icon="mdi-account"
                                            :error-messages="nombreErrores"
                                            :readonly="readonly"
                                        >
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="8">
                                        <v-text-field
                                            v-model="form.iban"
                                            label="IBAN"
                                            prepend-icon="mdi-bank"
                                            required
                                            :error-messages="ibanErrores"
                                            @blur="$v.form.iban.$touch()"
                                            :readonly="readonly"
                                            :hint="`Longitud ${form.iban ? form.iban.replace(/\s/g, '').length : 0} de 24-34`"
                                            persistent-hint
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="px-2" outlined>
                                <v-row align-self="center">
                                    <v-col cols="12" md="6">
                                        <v-select
                                            v-model="form.tipoDocumento"
                                            :items="
                                                opciones
                                                    ? opciones.cliente
                                                          .tipoDocumento
                                                    : []
                                            "
                                            label="Documento"
                                            item-text="human"
                                            item-value="encoded"
                                            required
                                            clearable
                                            single-line
                                            prepend-icon="mdi-card-account-details"
                                            :readonly="readonly"
                                            :error-messages="
                                                tipoDocumentoErrores
                                            "
                                        ></v-select>
                                    </v-col>
                                    <v-spacer></v-spacer>
                                    <v-col cols="12" md="6">
                                        <v-text-field
                                            v-model="form.documento"
                                            :error-messages="documentoErrores"
                                            :label="
                                                form.tipoDocumento
                                                    ? form.tipoDocumento
                                                    : 'Número de documento'
                                            "
                                            required
                                            @blur="$v.form.documento.$touch()"
                                            :readonly="readonly"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>

                    <v-row dense>
                        <v-col cols="12" md="3">
                            <div class="px-2" outlined>
                                <v-text-field
                                    v-model="form.email"
                                    :error-messages="emailErrores"
                                    prepend-icon="mdi-email"
                                    label="E-mail"
                                    required
                                    :readonly="readonly"
                                >
                                </v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" md="3">
                            <div class="px-2" outlined>
                                <v-text-field
                                    v-model="form.cups"
                                    label="CUPS"
                                    prepend-icon="mdi-home-lightning-bolt-outline"
                                    required
                                    :error-messages="cupsErrores"
                                    @blur="$v.form.cups.$touch()"
                                    :readonly="readonly"
                                ></v-text-field>
                            </div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div flat outlined class="px-2">
                                <v-row>
                                    <v-col cols="12" md="5">
                                        <v-text-field
                                            v-model="form.direccion.direccion"
                                            label="Dirección"
                                            prepend-icon="mdi-map-marker"
                                            required
                                            @blur="$v.form.direccion.$touch()"
                                            :error-messages="direccionErrores"
                                            :readonly="readonly"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="3">
                                        <v-text-field
                                            v-model="form.direccion.cp"
                                            label="CP"
                                            required
                                            type="number"
                                            :error-messages="cpErrores"
                                            prepend-icon="mdi-post"
                                            @blur="cpBlur"
                                            :readonly="readonly"
                                            @focus="cpFocused"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" md="4">
                                        <v-combobox
                                            v-model="form.direccion.localidad"
                                            :items="inferredLocalidades"
                                            :menu-props="localidadMenuProps"
                                            label="Localidad"
                                            required
                                            :error-messages="localidadErrores"
                                            @blur="
                                                $v.form.localidad.$touch();
                                                closeLocalidadMenu();
                                            "
                                            prepend-icon="mdi-city"
                                            :readonly="readonly"
                                            @click:item="closeLocalidadMenu"
                                        >
                                            <template v-slot:item="{ item }">
                                                <div
                                                    @click="closeLocalidadMenu"
                                                >
                                                    {{ item }}
                                                </div>
                                            </template>
                                        </v-combobox>
                                    </v-col>
                                </v-row>
                            </div>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="2">
                    <div
                        flat
                        outlined
                        fill-height
                        class="px-2"
                        style="height: 100%"
                    >
                        <v-row no-gutters>
                            <v-col
                                align-self="center"
                            >
                                <v-text-field
                                    v-model="telefono"
                                    label="Móvil"
                                    prepend-icon="mdi-cellphone"
                                    append-icon="mdi-plus-circle-outline"
                                    @keyup.enter="addTelefono"
                                    @click:append="addTelefono"
                                    :error-messages="telefonoErrores"
                                    type="number"
                                    counter="9"
                                    :readonly="readonly"
                                >
                                    <!-- @blur="$v.form.telefono.$touch()" -->
                                </v-text-field>
                                <div :style="!$vuetify.breakpoint.smAndDown ? 'overflow-x: hidden !important; overflow-y: scroll !important; max-height: 75px' : ''">
                                    <v-chip
                                        v-for="(
                                            curr_telf, index
                                        ) in form.telefonosContacto"
                                        :key="index"
                                        close
                                        @click:close="removeTelefono(curr_telf)"
                                        class="ma-1 d-flex justify-center"
                                    >
                                        {{ curr_telf }}
                                    </v-chip>
                                </div>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>
            <v-row dense>
                <v-col cols="12">
                    <div flat outlined class="px-2">
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="form.estado"
                                    :items="
                                        opciones ? opciones.cliente.estado : []
                                    "
                                    item-text="human"
                                    item-value="encoded"
                                    label="Estado"
                                    :error-messages="estadoErrores"
                                    required
                                    single-line
                                    prepend-icon="mdi-state-machine"
                                    :readonly="readonly"
                                >
                                </v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="form.segmento"
                                    :items="
                                        opciones
                                            ? opciones.cliente.segmento
                                            : []
                                    "
                                    label="Segmento"
                                    item-text="human"
                                    item-value="encoded"
                                    required
                                    single-line
                                    prepend-icon="mdi-account-details"
                                    :readonly="readonly"
                                    :error-messages="segmentoErrores"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="form.ispActual"
                                    :items="
                                        opciones ? opciones.cliente.isp : []
                                    "
                                    item-text="human"
                                    item-value="encoded"
                                    label="Operador"
                                    required
                                    single-line
                                    prepend-icon="mdi-access-point"
                                    :readonly="readonly"
                                    :error-messages="ispActualErrores"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-select
                                    v-model="form.origenBbdd"
                                    :items="origenesBbdd ? origenesBbdd : []"
                                    item-text="nombre"
                                    return-object
                                    label="Origen"
                                    :error-messages="origenBbddErrores"
                                    required
                                    single-line
                                    prepend-icon="mdi-database"
                                    :readonly="readonly"
                                >
                                </v-select>
                            </v-col>
                        </v-row>
                    </div>
                </v-col>
                <!-- <v-col cols="3">
                    <div flat outlined class="px-2">
                        <v-row no-gutters>
                            <v-col cols="12" md="12">
                                <v-select v-model="formComercial" :items="comerciales" label="Comercial" required
                                prepend-icon="mdi-account-tie" @blur="$v.form.comercial.$touch()" :readonly="readonly"></v-select>
                            </v-col>
                        </v-row>
                    </div>
                </v-col> -->
            </v-row>

            <div
                style="width: 100%; margin-bottom: -10px"
                v-if="!isReadonly"
                class="d-flex flex-wrap mt-2 justify-sm-center align-center"
            >
                <div
                    id="btn-left"
                    class="
                        d-flex
                        flex-wrap
                        justify-md-start justify-sm-center justify-xs-center
                        flex-grow-1
                        pb-xs-2
                        mx-xs-0 mx-sm-1 mx-md-0
                    "
                >
                    <div v-if="!readonly">
                        <v-btn
                            depressed
                            color="success"
                            :dark="isSaved"
                            :disabled="!isSaved"
                            :style="
                                $vuetify.breakpoint.smAndDown
                                    ? { width: '100%' }
                                    : {}
                            "
                            @click="nuevaOferta"
                            :class="$vuetify.breakpoint.smAndDown ? 'my-1' : 'mr-4'"
                        >
                            <v-icon left> mdi-plus-box </v-icon>
                            nueva oferta
                        </v-btn>
    
                        <v-btn
                            depressed
                            :class="$vuetify.breakpoint.smAndDown ? 'my-2' : 'mr-4'"
                            :style="
                                $vuetify.breakpoint.smAndDown
                                    ? { width: '100%' }
                                    : {}
                            "
                            color="purple"
                            :dark="isSaved"
                            :disabled="!isSaved"
                            @click="newAdministration"
                        >
                            <v-icon left> mdi-offer </v-icon>
                            nueva gestión
                        </v-btn>
    
                        <v-btn
                            depressed
                            :class="$vuetify.breakpoint.smAndDown ? 'my-1' : 'mr-4'"
                            :style="
                                $vuetify.breakpoint.smAndDown
                                    ? { width: '100%' }
                                    : {}
                            "
                            color="pink"
                            :dark="isSaved"
                            :disabled="!isSaved"
                            @click="schedule"
                        >
                            <v-icon left> mdi-calendar-arrow-right </v-icon>
                            agendar
                        </v-btn>
    
                        <v-btn
                            depressed
                            :class="$vuetify.breakpoint.smAndDown ? 'my-1' : 'mr-4'"
                            :style="
                                $vuetify.breakpoint.smAndDown
                                    ? { width: '100%' }
                                    : {}
                            "
                            color="orange"
                            :dark="isSaved"
                            :disabled="!isSaved"
                            @click="noInterest"
                        >
                            <v-icon left> mdi-phone-hangup </v-icon>
                            No vendido
                        </v-btn>
    
                        <v-btn
                            depressed
                            :class="$vuetify.breakpoint.smAndDown ? 'my-1' : 'mr-4'"
                            :style="
                                $vuetify.breakpoint.smAndDown
                                    ? { width: '100%' }
                                    : {}
                            "
                            color="#2c3a5c"
                            :dark="isSaved"
                            :disabled="!isSaved"
                            @click="nota"
                        >
                            <v-icon left> mdi-sticker-plus </v-icon>
                            Nota
                        </v-btn>
                    </div>
                </div>
                <div
                    class="
                        d-flex
                        flex-grow-1 flex-shrink-0
                        justify-center justify-md-end
                        mx-xs-0 mx-sm-1 mx-md-0
                        mt-1 mt-md-0
                    "
                >
                    <div
                        :style="
                            $vuetify.breakpoint.smAndDown
                                ? { width: '50%' }
                                : {}
                        "
                    >
                        <v-btn
                            depressed
                            color="indigo"
                            :dark="!hasChanged"
                            :disabled="hasChanged"
                            @click="submit"
                            style="width: 100%"
                            v-if="!readonly"
                        >
                            <v-icon left> mdi-content-save </v-icon>
                            guardar
                        </v-btn>
                    </div>
                    <div
                        :style="
                            $vuetify.breakpoint.smAndDown
                                ? { width: '50%' }
                                : {}
                        "
                        class=""
                    >
                        <v-btn
                            text
                            color="red"
                            @click="close"
                            style="width: 100%"
                        >
                            cerrar
                        </v-btn>
                    </div>
                </div>
            </div>

            <v-row
                no-gutters
                dense
                class="my-0 py-0"
                v-if="!readonly && !isReadonly"
            >
                <v-col>
                    <v-progress-linear
                        :active="uploadingForm"
                        :indeterminate="true"
                        absolute
                        bottom
                    >
                    </v-progress-linear>
                </v-col>
            </v-row>
        </v-form>

        <AdministrationForm />
        <ScheduleForm />
        <NoInterestForm />
        <NotasForm />
    </v-card>
</template>

<script>
import {
    email,
    required,
    maxLength,
    minLength,
} from 'vuelidate/lib/validators';
import { validNif, validNie, validCif } from '@/validators';
import axios from 'axios';
import { razonNoInteresadoTipo } from '@/util/optionsTtForm.json';
import {
    nombreErrores,
    tipoDocumentoErrores,
    documentoErrores,
    telefonoErrores,
    telefonosContactoErrores,
    emailErrores,
    cupsErrores,
    ibanErrores,
    direccionErrores,
    cpErrores,
    localidadErrores,
    origenBbddErrores,
    segmentoErrores,
    ispActualErrores,
    razonNoInteresadoErrores,
    estadoErrores,
} from './errorHandlers';

import { mapState, mapGetters } from 'vuex';
import { areEqualForm } from '@/util/libForm.js';
import { clone } from '@/util/libUtil.js';

// Import components
import AdministrationForm from './AdministrationForm';
import ScheduleForm from './ScheduleForm';
import NoInterestForm from './NoInterestForm';
import NotasForm from './NotasForm';

// Imports defaults forms
import defaultAtencionAgendadoForm from '@/util/atenciones/defaultAtencionAgendadoForm';
import defaultAtencionNoInterestForm from '@/util/atenciones/defaultAtencionNoInterestForm';
import defaultAtencionGestionForm from '@/util/atenciones/defaultAtencionGestionForm';
import defaultNotasForm from '@/util/atenciones/defaultNotasForm';
import { readonly } from 'vue';

export default {
    name: 'TtForm',
    props: ['propsForm', 'isReadonly'],
    data: () => ({
        comercial_name: '',
        comerciales: [],
        bools: {
            fechaContacto: false,
            fechaAgendado: false,
            fechaVenta: false,
            menuTelf: false,
        },
        telefono: '',
        razonNoInteresadoTipo,
        dialog: true,
        uploadingForm: false,
        hasChanged: false,
        inferredLocalidades: [],
        localidadMenuProps: {
            value: false,
            // openOnClick: true,
            // closeOnClick: true,
            // closeOnContentClick: true,
        },
        OfferComboBoxFilter: function (item, queryText, itemText) {
            itemText = item.nombre;
            return (
                itemText
                    .toLocaleLowerCase()
                    .indexOf(queryText.toLocaleLowerCase()) > -1
            );
        },
        isCPFocused: false,
    }),
    components: {
        AdministrationForm,
        ScheduleForm,
        NoInterestForm,
        NotasForm,
    },
    validations() {
        let functionTable = {
            NIF: validNif,
            NIE: validNie,
            CIF: validCif,
            PAS: () => true,
            Pasaporte: () => true,
        };

        let validDocumento =
            functionTable[
                this.form.tipoDocumento ? this.form.tipoDocumento : 'Pasaporte'
            ];
        let validIban = () => {
            const spanishIban = /^ES\d{2}\d{20}$/
            const iban = /^[A-Z]{2}\d{2}[A-Z0-9]{11,30}$/

            const cleanIban = this.form?.iban?.replace(/\s/g, '').toUpperCase();
            if (!cleanIban) return true; // Si el IBAN está vacío, no es un error de validación aquí (el campo requerido se encarga de eso)
            return spanishIban.test(cleanIban) || iban.test(cleanIban);
        };
        let ni = this.form.estado == 'No interesado' ? required : () => true;
        let identifier = () => {
            if (
                (this.form.telefonosContacto &&
                    this.form.telefonosContacto.length) ||
                this.form.email ||
                this.form.documento
            ) {
                return true;
            }
            return false;
        };

        let hasTypeOfDocument = () => {
            if (this.form.documento && !this.form.tipoDocumento) {
                return false;
            }
            return true;
        };

        let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
        let validTelefono = () => {
            return regexTelefono.test(this.telefono);
        };

        let form = {
            nombre: {
                required,
                max: maxLength(100),
            },
            cups: {
                min: minLength(20),
                max: maxLength(22),
            },
            iban: {
                min: minLength(24),
                max: maxLength(34),
                validIban,
            },
            tipoDocumento: {
                hasTypeOfDocument,
            },
            documento: {
                max: maxLength(30),
                validDocumento,
                identifier,
            },
            telefonosContacto: {
                identifier,
            },
            email: {
                email,
                identifier,
            },
            direccion: {},
            cp: {
                max: maxLength(5),
                min: minLength(5),
            },
            localidad: {},
            // fechaContacto: {
            //     required
            // },
            origenBbdd: {
                required,
            },
            segmento: {},
            comercial: {},
            ispActual: {},
            razonNoInteresado: {
                required: ni,
            },
        };

        const telefono = {
            max: maxLength(9),
            min: minLength(9),
            validTelefono,
        };
        return {
            form,
            telefono,
            validationGroup: ['form', 'telefono'],
        };
    },
    computed: {
        nombreErrores,
        tipoDocumentoErrores,
        documentoErrores,
        telefonoErrores,
        telefonosContactoErrores,
        emailErrores,
        cupsErrores,
        ibanErrores,
        direccionErrores,
        cpErrores,
        localidadErrores,
        origenBbddErrores,
        segmentoErrores,
        ispActualErrores,
        razonNoInteresadoErrores,
        estadoErrores,
        isSaved() {
            return this.form.id && typeof this.form.id == 'string';
        },
        cp() {
            return this.form.direccion.cp;
        },
        email() {
            return this.form.email;
        },
        form: {
            // Objeto que contiene el formulario con los datos del cliente
            get: function () {
                if (this.propsForm) {
                    return this.propsForm;
                }
                return this.$store.state.teletrabajo.TtForm;
            },
            set: function (val) {
                if (this.propsForm) {
                    return;
                }
                this.$store.commit('teletrabajo/TtForm', val);
            },
        },
        // methods: {
        //     submit() {
        //         this.$v.form.$touch();
        //         // console.log(this.$v)
        //         if (this.$v.form.$invalid) {
        //             // Si hay un error en los campos, el formulario es invalido
        //             //  console.log('error!')
        //             //  console.log(this.errors)
        //             this.$store.dispatch('util/showStatusSnackBar', {
        //                 // Mostrar la barrita de error arriba
        //                 statusType: 'error',
        //                 message: 'Hay un error en los campos',
        //             });
        //         } else {
        //             // console.log('submit!')
        //             // console.log(this.form.offer)
        //             this.$v.$reset();
        //             this.$store
        //                 .dispatch('teletrabajo/saveTtForm') // Se llama a la funcion guardar de la tienda
        //                 .then(() => {
        //                     // Esto se ejecuta si el servidor dice que se ha guardado bien
        //                     // if (this.$store.teletrabajo.TtFormType == 'create') {
        //                     //     this.$store.dispatch('teletrabajo/closeTtFormDialog')
        //                     // } else {
        //                     //     this.$store.dispatch('teletrabajo/closeCompleteViewTtFormDialog')
        //                     // }
        //                 });
        //         }
        //         this.form.comercial = this.comercialesDict.filter(
        //             (el) => el.name == val
        //         )[0];
        //     },
        //     get: function () {
        //         return this.form.comercial
        //             ? this.form.comercial.nombre
        //             : 'Por asignar';
        //     },
        //     close() {
        //         this.$store.dispatch('teletrabajo/closeTtFormDialog');
        //         // console.log(this.$store.state)
        //         if (this.$store.state.teletrabajo.TtFormType == 'create') {
        //             this.$store.dispatch('teletrabajo/setDefaultAddTtForm');
        //         } else {
        //             this.$store.dispatch(
        //                 'teletrabajo/closeCompleteViewTtFormDialog'
        //             );
        //         }
        //         this.clear();
        //         this.$v.$reset();
        //     },
        //     set: function (val) {
        //         this.form.fechaContacto = val;
        //     },
        // },
        fechaAgendado: {
            get: function () {
                if (!this.form.fechaAgendado) return;
                const [year, month, day] = this.form.fechaAgendado.split('-');
                return `${day}/${month}/${year}`;
            },
            set: function (val) {
                this.form.fechaAgendado = val;
            },
        },
        fechaVenta: {
            get: function () {
                if (!this.form.fechaVenta) return;
                const [year, month, day] = this.form.fechaVenta.split('-');
                return `${day}/${month}/${year}`;
            },
            set: function (val) {
                this.form.fechaVenta = val;
            },
        },
        dialogState: {
            get: function () {
                return this.$store.state.teletrabajo.IsOpenTtFormDialog;
            },
            set: function () {
                this.$store.dispatch('teletrabajo/closeTtFormDialog');
                if (this.$store.state.teletrabajo.TtFormType != 'create')
                    this.$store.dispatch('teletrabajo/setDefaultTtForm');
            },
        },
        todayString() {
            let tzoffset = new Date().getTimezoneOffset() * 60000;
            return new Date(Date.now() - tzoffset).toISOString().substr(0, 10);
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        // origenesTipo() {
        //     return this.origenesBbdd ? this.origenesBbdd.map((obj) => obj.nombre) : []
        // },
        origenesBbdd() {
            return JSON.parse(localStorage.getItem('origenesBbdd'));
        },
        ...mapState('teletrabajo', {
            readonly: (state) => state.TtFormType == 'view',
            ispTipo: (state) =>
                state.clienteOpciones
                    ? Object.values(state.clienteOpciones.isp)
                    : [],
            documentoTipo: (state) =>
                state.clienteOpciones
                    ? Object.values(state.clienteOpciones.tipo_documento)
                    : [],
        }),
        // ...mapState('util', {
        //     origenesBbdd: (state) => state.origenesBbdd,
        //     // opciones: (state) => state.opciones,
        // }),
        ...mapGetters('teletrabajo', {
            comercialesDict: 'allComerciales',
        }),
    },
    methods: {
        submit() {
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                // Si hay un error en los campos, el formulario es invalido
                //  console.log('error!')
                //  console.log(this.errors)
                this.$store.dispatch('util/showStatusSnackBar', {
                    // Mostrar la barrita de error arriba
                    statusType: 'error',
                    message: 'Hay un error en los campos',
                });
            } else {
                // console.log(this.form.offer)
                this.$v.$reset();
                this.$store
                    .dispatch('teletrabajo/saveTtForm') // Se llama a la funcion guardar de la tienda
                    .then(() => {
                        // Esto se ejecuta si el servidor dice que se ha guardado bien
                        // if (this.$store.teletrabajo.TtFormType == 'create') {
                        //     this.$store.dispatch('teletrabajo/closeTtFormDialog')
                        // } else {
                        //     this.$store.dispatch('teletrabajo/closeCompleteViewTtFormDialog')
                        // }
                    });
            }
        },
        clear() {
            this.$store.dispatch('teletrabajo/setDefaultTtForm');
        },
        close() {
            this.$store.dispatch('teletrabajo/closeTtFormDialog');
            // console.log(this.$store.state);
            if (this.$store.state.teletrabajo.TtFormType == 'create') {
                this.$store.dispatch('teletrabajo/closeTtFormDialog');
                this.$store.dispatch('teletrabajo/setDefaultAddTtForm');
            } else {
                this.$store.dispatch(
                    'teletrabajo/closeCompleteViewTtFormDialog'
                );
            }
            this.clear();
            this.$v.$reset();
        },
        addTelefono() {
            if (this.form.telefonosContacto.includes(this.telefono)) {
                this.$store.dispatch('util/showStatusSnackBar', {
                    // Mostrar la barrita de error arriba
                    statusType: 'error',
                    message: 'Teléfono ya añadido',
                });
                return;
            }

            this.$v.telefono.$touch();
            if (this.$v.telefono.$invalid) {
                return;
            }
            if (this.telefono === '') {
                return;
            }
            this.form.telefonosContacto.push(this.telefono);
            this.$v.telefono.$reset();
            this.telefono = '';
        },
        removeTelefono(telefono) {
            this.form.telefonosContacto.splice(
                this.form.telefonosContacto.indexOf(telefono),
                1
            );
        },
        nuevaOferta() {
            this.$store.commit(
                'teletrabajo/IsOpenCompleteViewTtFormDialog',
                false
            );
            this.$store.commit('configuradorOferta/configuratorType', 'CREATE');
            this.$store.commit('configuradorOferta/isp', {
                segment: 'PARTICULAR',
                isp: 'YOIGO',
            });

            this.$router.push({
                name: 'OfferConfigurator',
                params: { id: this.form.id },
            });
        },
        newAdministration() {
            let AdministrationForm = {
                isOpen: true,
                isSaving: false,
                isEditable: true,
                form: { ...clone(defaultAtencionGestionForm), gestion: null },
            };
            AdministrationForm.form.comercial =
                this.$store.getters['teletrabajo/selectedComercial'] ?? null;
            AdministrationForm.form.cliente = this.form;

            this.$store.commit(
                'teletrabajo/AdministrationForm',
                AdministrationForm
            );
        },
        nota() {
            let NotasForm = {
                isOpen: true,
                isSaving: false,
                isEditable: true,
                form: { ...clone(defaultNotasForm) },
            };
            NotasForm.form.comercial =
                this.$store.getters['teletrabajo/selectedComercial'] ?? null;
            NotasForm.form.cliente = this.form.id;

            this.$store.commit('teletrabajo/NotasForm', NotasForm);
        },
        schedule() {
            let ScheduleForm = {
                isOpen: true,
                isSaving: false,
                isEditable: true,
                form: clone(defaultAtencionAgendadoForm),
            };
            ScheduleForm.form.comercial =
                this.$store.getters['teletrabajo/selectedComercial'] ?? null;
            ScheduleForm.form.cliente = this.form;

            this.$store.commit('teletrabajo/ScheduleForm', ScheduleForm);
        },
        noInterest() {
            let NoInterestForm = {
                isOpen: true,
                isSaving: false,
                isEditable: true,
                form: clone(defaultAtencionNoInterestForm),
            };
            NoInterestForm.form.comercial =
                this.$store.getters['teletrabajo/selectedComercial'] ?? null;
            NoInterestForm.form.cliente = this.form;

            this.$store.commit('teletrabajo/NoInterestForm', NoInterestForm);
        },
        closeLocalidadMenu() {
            // console.log('close')
            this.localidadMenuProps = JSON.parse(
                JSON.stringify(this.localidadMenuProps)
            );
            this.localidadMenuProps.value = false;
        },
        cpFocused(val) {
            this.isCPFocused = true;
        },
        cpBlur(val) {
            this.isCPFocused = false;
            this.$v.form.cp.$touch();
        },
    },
    watch: {
        cp() {
            if (
                this.form.direccion.cp &&
                this.form.direccion.cp.length == 5 &&
                this.isCPFocused
            ) {
                axios
                    .get(
                        this.$store.getters['teletrabajo/LocalidadEndpoint'] +
                            this.form.direccion.cp
                    )
                    .then((response) => {
                        this.inferredLocalidades =
                            response.data.map(({ nombre }) => nombre) ?? [];
                        this.localidadMenuProps.value = true;
                        this.form.direccion.localidad = '';
                        // this.localidadMenuProps = JSON.parse(JSON.stringify(this.localidadMenuProps))
                    });
            }
        },
        email() {
            if (this.form.email)
                this.form.email = this.form.email.toLowerCase();
        },
        comercialesDict: {
            immediate: true,
            handler: function () {
                this.comerciales = Object.keys(this.comercialesDict)
                    .filter(
                        (key) =>
                            !this.comercialesDict[key].nombre.includes(
                                'invitado'
                            ) &&
                            !this.comercialesDict[key].nombre.includes(
                                'asignar'
                            )
                    )
                    .map((key) => this.comercialesDict[key].nombre);
                this.comerciales = [
                    ...this.comerciales,
                    ...Object.keys(this.comercialesDict)
                        .filter(
                            (key) =>
                                this.comercialesDict[key].nombre.includes(
                                    'invitado'
                                ) ||
                                this.comercialesDict[key].nombre.includes(
                                    'asignar'
                                )
                        )
                        .map((key) => this.comercialesDict[key].nombre),
                ];
            },
        },
        form: {
            deep: true,
            immediate: true,
            handler: function () {
                if (!this.propsForm) {
                    this.hasChanged = areEqualForm(
                        this.form,
                        this.$store.state.teletrabajo.UntouchedTtForm
                    );
                }
            },
        },
        form: {
            // Este solo comprueba que cambie la referencia del form, como señal
            // de que se ha cerrado o abierto otro y podemos borrar el campo telefono
            // (del campo de añadir telefono)
            deep: false,
            immediate: true,
            handler: function () {
                this.telefono = '';
            },
        },
    },
    // created() {
    //     this.$store.dispatch('teletrabajo/fetchComerciales');
    // },
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

/* Firefox */
input[type='number'] {
    -moz-appearance: textfield;
}
</style>
